import _ from 'lodash';
import {
    FETCH_MTOKNA_SELLER_NOTES,
    CLEAN_MTOKNA_SELLER_NOTES,
    CHANGE_MTOKNA_SELLER_NOTE,
    DELETE_MTOKNA_SELLER_NOTE,
} from './types';
import { request, __ } from '../functions';

export const fetchMtoknaSellerNotes = (screen, mtokna_seller_id, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/mtokna/sellerNotes/${mtokna_seller_id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_SELLER_NOTES, payload: data });
    });
};

export const changeMtoknaSellerNote = (screen, id, settings) => {
    return dispatch => request(`/mtokna/editSellerNote/${id}`, { settings }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť dohodu'));
            return;
        }

        screen.showSnackbar('success', __('Dohoda bola zmenená'));

        dispatch({ type: CHANGE_MTOKNA_SELLER_NOTE, payload: { id, settings } });
    });
};

export const deleteMtoknaSellerNote = (screen, id) => {
    return dispatch => request(`/mtokna/removeSellerNote/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmazať dohodu'));
            return;
        }

        screen.showSnackbar('success', __('Dohoda bola zmazaná'));

        dispatch({ type: DELETE_MTOKNA_SELLER_NOTE });
    });
};

export const cleanMtoknaSellerNotes = () => ({ type: CLEAN_MTOKNA_SELLER_NOTES });
